import swal from "sweetalert2";

/**
 * EL AVISO DE «QUEDÓ COMO PROPUESTA».
 *
 * Con el control de cambios encendido (iso42001.matriz.aprobacion=true, el
 * valor de producción) lo que se guarda en la matriz NO se aplica: el
 * servidor lo deja como propuesta y contesta quedoPendiente=true. Hasta el
 * 24/09/2026 ninguna pantalla lo leía: se veía el «Listo» de siempre, o
 * nada, y como después se relee del servidor el cambio «se regresaba» solo.
 *
 * Cada pantalla que guarda en la matriz (el editor del activo, la matriz
 * completa y el plan RSK) llama aquí en vez de su mensaje de éxito cuando
 * quedoComoPropuesta(res). No pinta nada como aplicado: la pantalla relee
 * del servidor, que sigue como estaba.
 *
 * Además avisa por un evento de window, para que el botón «Cambios por
 * aprobar» del libro actualice su número sin recargar.
 */
export const EVENTO_PROPUESTA = "cos-matriz-propuesta";

export function quedoComoPropuesta(res: { quedoPendiente?: boolean } | null | undefined): boolean {
  return !!(res && res.quedoPendiente);
}

/**
 * @param que lo que se guardó, como sujeto de la frase: «El cambio de
 *            ACT-001», «El corte nuevo», «La baja de ACT-005».
 */
export function avisarPropuesta(que: string): Promise<unknown> {
  try {
    window.dispatchEvent(new CustomEvent(EVENTO_PROPUESTA));
  } catch {
    // Sin el evento sólo tarda en cambiar el número del botón.
  }
  return swal.fire({
    icon: "info",
    title: "Quedó como propuesta",
    text: que + " espera aprobación en «Cambios por aprobar». Hasta que se acepte, la matriz sigue como estaba.",
    confirmButtonText: "Entendido",
  });
}
